<header>
  <nav
    class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light border-bottom box-shadow mb-3" style="background-color: #11387F;" >
    <div class="container">
      <a class="navbar-brand" [routerLink]="['/']"><img src="assets/logo.png" alt="logo"> Global Item Registry (GIR) Admin Tool ({{env}})</a>

    <button class="navbar-toggler"
      type="button"
      (click)="toggle()"
      [attr.aria-expanded]="isExpanded"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse collapse d-sm-inline-flex justify-content-end"
      [ngClass]="{ show: isExpanded }">
      <ul class="navbar-nav flex-grow">
        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a class="nav-link text-white" [routerLink]="['/']">Home</a>
        </li>

        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a class="nav-link text-white" [routerLink]="['/items']" (click)="navigateAndCollapse('/items')">Items</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a class="nav-link text-white" [routerLink]="['/suppliers']" (click)="navigateAndCollapse('/suppliers')">Suppliers</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a class="nav-link text-white" [routerLink]="['/parking-lot']" (click)="navigateAndCollapse('/parking-lot')">Parking lot</a>
        </li>

        @if (hasAISearchAccess) {
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link text-white" [routerLink]="['/ai-search']" (click)="navigateAndCollapse('/ai-search')">AI Search</a>
          </li>
        }

        @if (isAdmin) {
          <li class="nav-item dropdown">
            <span dropdown>
              <a href class="nav-link dropdown-toggle text-white" dropdownToggle (click)="false" id="administrationDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Administration</a>
              <div class="dropdown-menu dropdown-menu-end" *dropdownMenu aria-labelledby="administrationDropdown">
                <a class="dropdown-item" [routerLink]="['/upload-items']" (click)="navigateAndCollapse('/upload-items')">Upload Items</a>
                <a class="dropdown-item" [routerLink]="['/force-publish']" (click)="navigateAndCollapse('/force-publish')">Force Publish</a>
                <a class="dropdown-item" [routerLink]="['/audit-log']" (click)="navigateAndCollapse('/audit-log')">Audit Log</a>
                <a class="dropdown-item" [routerLink]="['/allowed-suppliers']" (click)="navigateAndCollapse('/allowed-suppliers')">Allowed Suppliers</a>
                <a class="dropdown-item" [routerLink]="['/apim-subscriptions']" (click)="navigateAndCollapse('/apim-subscriptions')">APIM Subscriptions</a>
                <a class="dropdown-item" [routerLink]="['/sources']" (click)="navigateAndCollapse('/sources')">Sources</a>
                <a class="dropdown-item" [routerLink]="['/supplier-lookup']" (click)="navigateAndCollapse('/supplier-lookup')">Supplier Lookup</a>
                <a class="dropdown-item" [routerLink]="['/force-publish-receivers']" (click)="navigateAndCollapse('/force-publish-receivers')">Force Publish Receivers</a>
                <a class="dropdown-item" [routerLink]="['/system-language-codes']" (click)="navigateAndCollapse('/system-language-codes')">System Language Codes</a>
                <a class="dropdown-item" [routerLink]="['/batch-consumers']" (click)="navigateAndCollapse('/batch-consumers')">Batch Consumers</a>
              </div>
            </span>
          </li>
        }

        <!-- <li class="nav-item dropdown" *ngIf="isAdmin">
        <span dropdown>
          <a href class="nav-link dropdown-toggle" dropdownToggle (click)="false" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="color: white;">Tools</a>
          <div class="dropdown-menu dropdown-menu-end" *dropdownMenu aria-labelledby="navbarDropdown">
            <a class="dropdown-item" *ngIf="isAdmin" [routerLink]="['/upload-items']">Upload Items</a>
          </div>
        </span>
      </li> -->

    </ul>
  </div>

  <!-- <div id="collapseBasic" [collapse]="isCollapsed" class="navbar-collapse collapse d-sm-inline-flex justify-content-end">
  <ul class="navbar-nav flex-grow">
    <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
      <a class="nav-link" [routerLink]="['/']" style="color: white;">Home</a>
    </li>

    <li class="nav-item" [routerLinkActive]="['link-active']">
      <a class="nav-link" [routerLink]="['/items']" style="color: white;">Items</a>
    </li>

    <li class="nav-item" [routerLinkActive]="['link-active']">
      <a class="nav-link" [routerLink]="['/parking-lot']" style="color: white;">Parking lot</a>
    </li>

    <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="isAdmin">
      <a class="nav-link" [routerLink]="['/upload-items']" style="color: white;">Upload Items</a>
    </li>

    <li class="nav-item dropdown" *ngIf="isAdmin">
      <span dropdown>
        <a href class="nav-link dropdown-toggle" dropdownToggle (click)="false" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="color: white;">Tools</a>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu aria-labelledby="navbarDropdown">
          <a class="dropdown-item" *ngIf="isAdmin" [routerLink]="['/upload-items']">Upload Items</a>
        </div>
      </span>
    </li>
  </ul>
</div> -->

</div>
</nav>
</header>
